@if (loading()) {
  <div class="tw-flex tw-items-center tw-justify-center tw-h-full">
    <loading class="tw-justify-center tw-self-center"></loading>
  </div>
} @else {
  <div class="tw-grid tw-grid-cols-[40px_1fr_40px] tw-w-full tw-h-14 tw-px-6 tw-bg-teal-200 tw-z-[101] tw-items-center tw-flex-shrink-0 tw-text-black tw-sticky tw-top-0">
    <div class="tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center tw-rounded-xl" (click)="back()">
      <cs-icon class="tw-h-6 tw-w-6" [iconName]="'arrow_back'"></cs-icon>
    </div>

    <span class="tw-text-300 tw-font-lexend tw-font-bold tw-justify-self-center" i18n="@@shopProducts">
      Shop products
    </span>

    <div class="tw-h-10 tw-w-10 tw-relative tw-flex tw-items-center tw-justify-center" (click)="goToCart()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]="'shopping_cart'"></cs-icon>
      <span class="tw-absolute -tw-top-1 tw-right-1 tw-font-body tw-font-bold tw-h-[14px] tw-text-200 tw-text-red-400">{{numberOfProductsInCart}}</span>
    </div>
  </div>

  <app-regimen-products-list
    [products]="products"
    [userName]="userName"
    [userPhoto]="userPhoto"
    [productsInCart]="productsInCart"
    [regimens]="regimens"
    [activeRegimenClass]="activeRegimenClass"
    (addToCart)="onAddToCart($event)"
    (removeFromCart)="onRemoveFromCart($event)"
    (buyKit)="onBuyKit($event)"
    (gotoProduct)="onLockedProductClick($event)">
  </app-regimen-products-list>

  <div class="tw-flex tw-flex-col tw-p-4 tw-pt-6 tw-bg-gray-100">
    <span class="tw-font-lexend tw-font-bold tw-text-500 tw-text-black" i18n="@@ourFullRange">Our Full Range</span>
    <span class="tw-font-body tw-text-100 tw-text-gray-500" i18n="@@buyFirstTreatmentKit">Buy your first treatment kit to explore our full range of products.</span>
  </div>

  @for (name of shopSectionOrder; track $index;) {
    @let displayType = getDisplayType(name);
    @if (displayType === DisplayType.STANDARD) {
      <app-product-collection [id]="name"
                              class="tw-block tw-mb-2 tw-scroll-mt-48"
                              [collection]="shopCollections[name]">
        @for (product of shopCollections[name]?.products; track $index) {
          <app-product [product]="product"
                       [productInCart]="productsInCart[product.objectId]"
                       [isLocked]="!availableProductIds.includes(product.objectId)"
                       [isShopRevampExperimentOn]="true"
                       (addToCart)="onAddToCart($event)"
                       (reomveFromCart)="onRemoveFromCart($event)"
                       (gotoProduct)="gotoProduct($event, name)" />
        }
      </app-product-collection>
    }
    <!-- Banner type -->
    @if (displayType === DisplayType.BANNER || displayType === DisplayType.PURPOSE_SUBTEXT_BANNER || displayType === DisplayType.PURPOSE_HEADER_BANNER) {
      <app-product-collection-banner [id]="name"
                                     class="tw-block tw-mb-2 tw-scroll-mt-48"
                                     [collection]="shopCollections[name]">
        <swiper class="swiper-wrapper tw-mb-4"
                [config]="getSwiperConfig($index, name)">
          @for (product of shopCollections[name]?.products; track $index) {
            <app-product-horizontal *swiperSlide
                                    [product]="product"
                                    [productInCart]="productsInCart[product.objectId]"
                                    [isLocked]="!availableProductIds.includes(product.objectId)"
                                    [type]="displayType"
                                    (addToCart)="onAddToCart($event)"
                                    (reomveFromCart)="onRemoveFromCart($event)"
                                    (gotoProduct)="gotoProduct($event, name)" />
          }
        </swiper>
        <div class="tw-w-auto tw-flex tw-items-center tw-gap-1 tw-mx-auto tw-overflow-auto"
             [id]="'swiper-pagination-' + $index"></div>
      </app-product-collection-banner>
    }
    <!-- Jumbo type -->
    @if (displayType === DisplayType.ENLARGED_CARDS) {
      <app-product-collection-jumbo [id]="name"
                                    class="tw-block tw-mb-2 tw-scroll-mt-48"
                                    [collection]="shopCollections[name]"
                                    [products]="shopCollections[name]?.products"
                                    [productInCart]="productsInCart"
                                    [isInfiniteLoopEnabled]="true"
                                    (addToCart)="onAddToCart($event)"
                                    (reomveFromCart)="onRemoveFromCart($event)"
                                    (gotoProduct)="gotoProduct($event, name)">
      </app-product-collection-jumbo>
    }
  }

  @if (numberOfProductsInCart > 0 && isCheckoutStickyVisible) {
    <cart-detail-strip
      [numberOfProductsInCart]="numberOfProductsInCart"
      [user]="user"
      (closeStrip)="isCheckoutStickyVisible = false">
    </cart-detail-strip>
  }
}

<div class="tw-sticky tw-bottom-0 tw-z-[101]">
  @if (isBottomNavExperimentActive) {
    <app-bottom-nav [user]="user" />
  } @else {
    <div class="tw-flex tw-justify-around tw-w-full tw-overflow-hidden tw-h-20 tw-bg-white">
      <div class="tw-h-full tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(0)">
        <div class="tw-flex-none tw-w-11 tw-h-1 tw-rounded-br tw-rounded-bl tw-bg-teal-400"></div>
        <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
          <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_home_solid.svg"'></cs-icon>
          <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@home">Home</div>
        </div>
      </div>
      <div class="tw-h-full tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(1)">
        <div class="tw-flex-none tw-w-11 tw-h-1 tw-rounded-br tw-rounded-bl tw-bg-white"></div>
        <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
          <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_help.svg"'></cs-icon>
          <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@help">Help</div>
        </div>
      </div>
      <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="cameraClickHome()">
        <div class="tw-flex-none tw-w-11 tw-h-1 tw-bg-white"></div>
        <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
          <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_photo_camera.svg"'></cs-icon>
          <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@photo">Photo</div>
        </div>
      </div>
      <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(2)">
        <div class="tw-flex-none tw-w-11 tw-h-1 tw-rounded-br tw-rounded-bl tw-bg-white"></div>
        <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
          <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_sanitizer.svg"'></cs-icon>
          <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@treatment">
            Treatment
          </div>
        </div>
      </div>
      <div *ngIf="showExploreTab" class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3" rippleEffect="rippleEffect" (callback)="onTabChange(3);exploreClick()">
        <div class="tw-flex-none tw-w-11 tw-h-1 tw-rounded-br tw-rounded-bl tw-bg-white"></div>
        <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
          <cs-icon class="tw-h-7 tw-w-7 tw-text-gray-500" [iconName]='"https://cdn.cureskin.com/app/img/rebranded_manage_search.svg"'></cs-icon>
          <div class="tw-font-body tw-text-200 tw-text-gray-500" i18n="@@explore">Explore</div>
        </div>
      </div>
    </div>
  }
</div>
